<template>
  <div class="">
    <div
      class="padding l:padding-l bg-gray-1 border-thin-gray-2 border-radius-s">
      <form-button
        v-if="layout !== 'inline'"
        :text="expanded ? 'core.form.presetObject.stopEditCta':'core.form.presetObject.editCta'"
        icon="pencil"
        @click.prevent.stop="expanded = !expanded"></form-button>
      <component
        :is="wrapperElement"
        :show="expanded || layout === 'inline'"
        class="padding-m-vertical animate__fadeInDownSmall animate--fastest"
        :class="{'hidden' : ! expanded && layout !== 'inline'}"
        :size="modalSize"
        :title="modalTitle"
        :title-params="modalTitlePrams"
        @modal:closed="expanded = false">
        <template #default>
          <div class="padding l:padding-l bg-gray-1 border-thin-gray-2 border-radius-s">
            <form-field-set
              v-if="value"
              class="preset-object-fieldset margin-remove"
              :max-fields-per-row="maxFieldsPerRow">
              <form-input
                v-for="(field, key) of fields"
                :wrapper-margins="false"
                v-bind="field"
                :model-value="value[key]"
                @field:changed="(val) => (value[key] = val)">
              </form-input>
            </form-field-set>
          </div>
        </template>
      </component>
      <form-button
        v-if="layout === 'collapsible' && expanded"
        text="core.form.presetObject.stopEditCta"
        icon="pencil"
        @click.prevent.stop="expanded = !expanded"></form-button>
    </div>

  </div>
</template>

<script>
import presetObjectInputMixin from "@/client/extensions/mixins/baseComponents/form/controls/input/presetObjectInput";
export default {
  mixins: [presetObjectInputMixin],
  props: {

  },

  data: function () {
    return {
      expanded: false,
    };
  },
  computed: {},
  watch: {
    value: {
      handler: "enforceValueIntegrity",
      deep: true,
      immediate: true,
    },
  },
  beforeMount() {
    this.enforceValueIntegrity();
  },
  methods: {},
};
</script>

